import type { FrameArtworkProfile } from '../types/doorConfiguration';

const VARIANT_SELECTORS: Record<FrameArtworkProfile, string> = {
  chamfered: '#variant-chamfered',
  sculptured: '#variant-ovolo',
  // timberbutt.svg currently ships the same authored group id as sculptured.
  timberbutt: '#variant-ovolo',
};

/**
 * Build same-document sprite markup from a colour-ready profile asset.
 *
 * The selected variant retains its authored transforms, definitions, profile
 * geometry, and palette classes. Slab and lower-assembly layers are excluded
 * because those are rendered from calculated product geometry.
 */
export function extractFrameProfileSpriteMarkup(
  markup: string,
  profile: FrameArtworkProfile
): string | null {
  const document = new DOMParser().parseFromString(markup, 'image/svg+xml');
  if (document.querySelector('parsererror')) return null;

  const root = document.documentElement;
  const variant = root.querySelector<SVGGElement>(VARIANT_SELECTORS[profile]);
  if (!variant) return null;

  const sprite = variant.cloneNode(true) as SVGGElement;
  sprite
    .querySelectorAll(
      '[data-role="door-slab"], #rect1, [id*="-threshold"], [id*="-cill"]'
    )
    .forEach((node) => node.remove());

  const rootDefs = Array.from(root.children).find(
    (node) => node.tagName.toLowerCase() === 'defs'
  );
  return `${rootDefs?.outerHTML ?? ''}${sprite.outerHTML}`;
}
